import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useGridApiContext, useGridSelector, gridFilterModelSelector } from '@mui/x-data-grid-pro';
import { formatDateText } from './dates';

// New UI: the grid's active column filters as removable chips under its toolbar (EnhancedDataGrid). Removing a chip or
// clearing all goes through the grid's own filter API, the same path as Classic's filter panel. Renders nothing when
// no column filter is set.
const OPS = {
	contains: 'contains', equals: '=', startsWith: 'starts with', endsWith: 'ends with', isEmpty: 'is empty', isNotEmpty: 'is not empty',
	isAnyOf: 'is any of', is: '=', not: '≠', after: 'after', onOrAfter: 'on or after', before: 'before', onOrBefore: 'on or before',
	'=': '=', '!=': '≠', '>': '>', '>=': '≥', '<': '<', '<=': '≤'
};
const NO_VALUE = ['isEmpty', 'isNotEmpty'];

// A chip reads like the cells: dates as MM/DD/YYYY, Y / N as Yes / No, and "Archived: No" for an equals filter (R18).
const EQUALS = ['is', 'equals', '='];
const YN = { Y: 'Yes', N: 'No', y: 'Yes', n: 'No', true: 'Yes', false: 'No' };
export function chipValue(v) {
	if (Array.isArray(v)) return v.map(chipValue).join(', ');
	if (v instanceof Date) return formatDateText(v.toISOString().slice(0, 10));
	const s = String(v);
	return YN[s] || formatDateText(s);
}
export function chipText(col, operator, value) {
	if (NO_VALUE.includes(operator)) return `${col} ${OPS[operator] || operator}`;
	return EQUALS.includes(operator) ? `${col}: ${chipValue(value)}` : `${col} ${OPS[operator] || operator} ${chipValue(value)}`;
}

export function activeItems(model) {
	return ((model && model.items) || []).filter(it => NO_VALUE.includes(it.operator) || (Array.isArray(it.value) ? it.value.length > 0 : it.value !== undefined && it.value !== null && String(it.value) !== ''));
}

// inline: inside a report's settings bar, without its own row or "Clear filters" wrapper spacing.
export default function ActiveFilterChips({ inline } = {}) {
	const apiRef = useGridApiContext();
	const model = useGridSelector(apiRef, gridFilterModelSelector);
	const items = activeItems(model);
	if (!items.length) return null;
	const colName = field => { try { const c = apiRef.current.getColumn(field); return (c && c.headerName) || field; } catch (e) { return field; } };
	return (
		<div className={'apw2-grid-filters' + (inline ? ' inline' : '')} role="group" aria-label="Active filters">
			{items.map((it, i) => (
				<span key={it.id ?? i} className="apw2-filter-chip">
					<span>{chipText(colName(it.field), it.operator, it.value)}</span>
					<button type="button" aria-label={`Remove filter ${colName(it.field)}`} onClick={() => apiRef.current.deleteFilterItem(it)}><CloseIcon fontSize="inherit" /></button>
				</span>
			))}
			<button type="button" className="apw2-linkbtn" onClick={() => apiRef.current.setFilterModel({ ...model, items: [] })}>Clear filters</button>
		</div>
	);
}
